/**
 * @relatedFiles ./theme-provider.tsx, ./clerk-theme-provider.tsx, ../app/layout.tsx
 * @purpose Dynamically updates browser theme-color meta tag based on current theme for native app integration
 */
'use client';

import { useTheme } from 'next-themes';
import { useEffect } from 'react';

export function ThemeColorMeta() {
  const { theme, resolvedTheme } = useTheme();

  useEffect(() => {
    let metaThemeColor = document.querySelector('meta[name="theme-color"]');
    
    if (!metaThemeColor) {
      metaThemeColor = document.createElement('meta');
      metaThemeColor.setAttribute('name', 'theme-color');
      document.head.appendChild(metaThemeColor);
    }

    const themeToUse = resolvedTheme || theme;
    const color = themeToUse === 'dark' ? '#19191a' : '#f9f9f6';
    metaThemeColor.setAttribute('content', color);
  }, [theme, resolvedTheme]);

  return null;
} 